import React from 'react';
import $ from "jquery/dist/jquery.min.js";

import { MarkerIcon } from '../map/icon';

const Marker = ({ text, setCurrentId, currentId }) => {
  const handleClick = (e) => {
    setCurrentId(e.currentTarget.dataset.myobjid)
    $('html, body').animate({
      scrollTop: $(e.currentTarget.dataset.myobjid).offset().top
    }, 500);

    $(e.currentTarget.dataset.myobjid).addClass("active").siblings().removeClass("active")
    //$(".map-marker-"+hit.objectID).addClass("active").siblings().removeClass("active")
  }
  return (
    <div className="marker" style={{ width: 40, height: 40, pointerEvents: "all" }} data-myobjid={text} onClick={handleClick} role="presentation">
      {text != "noProp" &&
        <MarkerIcon active={text == currentId} />
      }

    </div>
  )
}

export default Marker;